import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'ciao-tool-tip',
    templateUrl: './tool-tip.component.html',
    styleUrls: ['./tool-tip.component.less'],
    standalone: false
})
export class ToolTipComponent implements OnInit {
  @Input() title: string;
  @Input() message: string;

  constructor() {}

  ngOnInit(): void {}
}
